import React from "react";
import { Reveal } from "@/components/shared/Reveal";

export const SectionHeading = ({ kicker, title, subtitle, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-3xl"} ${className}`}>
    {kicker && (
      <Reveal>
        <span className="kicker inline-flex items-center gap-2">
          <span className="h-px w-6 bg-primary/70" />
          {kicker}
        </span>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-foreground sm:text-4xl lg:text-[2.75rem]">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
